<ion-app>
<!--  <router-outlet></router-outlet>-->
  <ion-router-outlet [animated]="true" [environmentInjector]="environmentInjector"></ion-router-outlet>
  <app-page-tabs></app-page-tabs>
  <div class="b2p-container__close" (click)="closeB2P()" style="z-index: 1000001">&#10005;</div>
  <div class="b2p-container" style="z-index: 1000000"></div>
</ion-app>
